import { v4 as uuidv4 } from "uuid";

export class FormField extends HTMLElement {
  uuid = uuidv4();
  inValidationMode = false;

  inputElement = null;

  get label() {
    return this.getAttribute('label') || undefined;
  }

  get name() {
    return this.getAttribute('name') || undefined;
  }

  get isRequired() {
    return this.hasAttribute('required') && this.getAttribute('required') !== 'false';
  }

  get errorMessage() {
    return this.getAttribute('error-message') || "Bitte füllen Sie dieses Feld aus.";
  }

  get submitValueType() {
    return "string";
  }

  get submitValue() {
    return this.inputElement?.value || undefined;
  }

  get submitData() {
    if (this.name === undefined || this.submitValue === undefined) return null;

    return {
      name: this.name,
      value: this.submitValue,
      type: this.submitValueType,
    };
  }

  get isValid() {
    return this.inputElement?.checkValidity() || false;
  }

  connectedCallback() {
    this.initFormField();
  }

  static get observedAttributes() {
    return ["label", "required"];
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    if (oldValue === newValue) return;
    this.renderComponent();
  }

  async initFormField() {
    await this.renderComponent();
    this.inputElement = this.querySelector('.zhi-form-field__input');
    this.inputElement?.addEventListener('input', () => this.handleInputChanged());
  }

  async renderComponent() {
    // needs to bee overridden
  }

  handleInputChanged() {
    if (this.inValidationMode) this.validate();
  }

  validate() {
    const isValid = this.isValid;
    this.toggleAttribute('has-error', !isValid);
    this.inValidationMode = true;
    this.renderComponent();
  }
}